import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { BankAndApp, BtnLogin, BtnRegister, Chars, Logo } from "src/assets";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">TOP268</VisuallyHidden>

      <img
        alt="chars"
        src={Chars}
        style={{ width: 308, marginTop: "-2px" }}
      />

      <img
        alt="logo"
        src={Logo}
        style={{ width: 284, marginTop: "-40px" }}
      />

      <Stack
        direction="row"
        justifyContent="center"
        zIndex={10}
        gap={1.5}
        mt={"6px"}
      >
        <a
          href={loginUrl}
          onClick={handleClick("login")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="btn-login"
            src={BtnLogin}
            style={{ height: 45, marginTop: "4px" }}
          />
        </a>
        <a
          href={registerUrl}
          onClick={handleClick("register")}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="btn-register"
            src={BtnRegister}
            style={{ height: 54 }}
          />
        </a>
      </Stack>

      <img
        alt="bank-and-app"
        src={BankAndApp}
        style={{ width: 190, marginTop: "64px" }}
      />
    </Box>
  );
};

const styles = createStyles({
  root: {
    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
